import { NumberField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { BonusEmailStatus } from '@/data/models/domain/types'

@OrmModel(modelNames.BONUS_INFO)
export default class BonusInfo extends BaseModel {
  @NumberField()
  public emails: number

  @NumberField()
  public emailLookups: number

  @StringField()
  public emailStatus: BonusEmailStatus

  public get hasAvailableEmailsBonuses() {
    return this.emails !== 0
  }

  public get hasAvailableEmailLookupsBonuses() {
    return this.emailLookups !== 0
  }

  public get hasAvailableEmailsOrEmailLookupsBonuses() {
    return this.hasAvailableEmailsBonuses || this.hasAvailableEmailLookupsBonuses
  }
}
